import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { DefaultCarrierEntryFragmentFragmentDoc } from './defaultCarrierEntry.generated';
import { AvailableCarrierServiceFragmentFragmentDoc } from './availableCarrierService.generated';
export type StoreAdminFragmentFragment = { __typename?: 'Store', id: string, geo_hash?: string | null, eat_in_option?: boolean | null, online?: boolean | null, published?: boolean | null, can_preorder?: boolean | null, can_deliver?: boolean | null, always_online?: boolean | null, show_in_stats?: boolean | null, coming_soon?: boolean | null, permanently_removed?: boolean | null, name?: string | null, phone_number?: string | null, website?: string | null, description?: string | null, location_name?: string | null, region?: number | null, type?: Types.StoreType | null, available_soon: boolean, available_from?: string | null, has_wolt: boolean, lieferando_url?: string | null, wolt_url?: string | null, habgusta_url?: string | null, mjam_url?: string | null, labonapp_url?: string | null, ubereats_url?: string | null, split_app_url?: string | null, too_good_to_go_url?: string | null, rappi_url?: string | null, didi_food_url?: string | null, foodora_url?: string | null, google_places_id?: string | null, food_info_de?: string | null, food_info_en?: string | null, description_de?: string | null, description_en?: string | null, description_fr?: string | null, description_nl?: string | null, description_no?: string | null, description_et?: string | null, description_el?: string | null, description_hu?: string | null, description_es?: string | null, description_sv?: string | null, description_pt?: string | null, description_lb?: string | null, description_da?: string | null, description_pl?: string | null, description_al?: string | null, description_ca?: string | null, description_eu?: string | null, description_gl?: string | null, contracted_date?: string | null, contract_end_date?: string | null, temporary_access_from?: string | null, onboarded_date?: string | null, test_period_end?: string | null, menu_link?: string | null, accepted_container_type_group_ids?: Array<number | null> | null, invoice_headline?: string | null, min_order_time?: number | null, cancelation_time?: number | null, block_campaigns?: boolean | null, phone_from_vytal?: boolean | null, sim_info?: string | null, sim_phone_number?: string | null, sim_payment_automation?: boolean | null, offline_card_cost?: number | null, invoice_email?: string | null, legal_name?: string | null, onboarding_fee_vytal?: number | null, acquired_by?: string | null, acquired_at?: string | null, debitor_account_number?: number | null, preorder_sms_number?: string | null, internal_comment?: string | null, min_delivery_order_value?: number | null, min_delivery_time?: number | null, delivery_fee?: number | null, invoice_email_subject_prefix?: string | null, invoice_iban_name?: string | null, invoice_iban?: string | null, partner_newsletter_email?: string | null, country_code?: string | null, created_by?: string | null, food_categories?: Array<Types.FoodCategory | null> | null, currency?: Types.Currency | null, partner_credits?: number | null, partner_credits_usable_until?: string | null, store_wide_discount_percent?: number | null, minimum_monthly_transaction_charge?: number | null, monthly_service_fee?: number | null, monthly_flat_fee?: number | null, use_circulation_based_billing?: boolean | null, offline_timeout?: string | null, manual_overwrite_store_info?: boolean | null, disable_automatic_partner_invoice_sending?: boolean | null, disable_automatic_partner_charging?: boolean | null, external_salesforce_id?: string | null, external_zoho_crm_id?: string | null, charge_onboarding_fee?: boolean | null, external_vytal_id?: string | null, store_layout?: Array<string | null> | null, store_layout_vending_machines_json?: string | null, tier?: Types.StoreTier | null, revenue_tier?: Types.StoreTier | null, feature_container_collection_enabled?: boolean | null, allow_inventory_checks_for_terminal_users?: boolean | null, allow_inventory_checks_for_terminal_users_until?: string | null, allow_inventory_checks_for_terminal_users_permanently?: boolean | null, additional_allowance?: number | null, additional_allowance_valid_until?: string | null, last_google_opening_hours_sync?: string | null, is_net_receiver?: boolean | null, non_usage_fee_enabled?: boolean | null, charge_non_usage_fee?: boolean | null, dpd_pickup_compulsory?: boolean | null, vat_number?: string | null, permanently_closed?: boolean | null, employee_only: boolean, send_nuf_info_to_invoice_address?: boolean | null, nuf_comment?: string | null, excluded_from_nuf_until?: string | null, currency_symbol?: string | null, has_return_box_published_in_app: boolean, can_order_secondary_portfolio: boolean, default_inventory_check_expiration_days: number, new_inventory_checks_are_non_billable: boolean, sustainability_reports_enabled: boolean, invoice_routing_id?: string | null, order_number?: string | null, seller_id?: string | null, service_package_type?: Types.ServicePackageType | null, service_package_start_date?: string | null, free_checkout_segment?: Types.ContainerTypeSegment | null, external_id?: string | null, invoice_yearly?: boolean | null, needs_purchasing_order_number?: boolean | null, purchasing_order_email?: string | null, yearly_renewal_fee?: number | null, yearly_renewal_fee_month?: number | null, preferred_locale?: string | null, regular_payment_target_days?: number | null, sepa_2_percent_discount?: boolean | null, dunning_reminder_block_type?: Types.DunningReminderBlockType | null, dunning_reminder_block_reason?: string | null, dunning_reminder_block_until?: string | null, is_dunning_reminder_stopped?: boolean | null, inkassokennzeichen?: boolean | null, invoicing_disabled_permanently?: boolean | null, invoicing_disabled_until?: string | null, is_invoicing_currently_disabled?: boolean | null, onboarding_status?: Types.OnboardingStatus | null, removal_reason?: string | null, integrations?: Array<string | null> | null, credit_to_partner?: string | null, lonlat?: { __typename?: 'LonLat', longitude?: number | null, latitude?: number | null } | null, linked_city?: { __typename?: 'Location', id?: string | null, name?: string | null, store_count?: number | null } | null, labels?: Array<{ __typename?: 'StoreLabel', text?: string | null, color?: string | null, text_color: string } | null> | null, opening_hours_multi_raw?: Array<{ __typename?: 'OpeningHoursMulti', day: number, time?: Array<string | null> | null } | null> | null, special_opening_hours_multi?: Array<{ __typename?: 'SpecialOpeningHoursMulti', day: string, time?: Array<string | null> | null } | null> | null, delivery_hours_raw?: Array<{ __typename?: 'OpeningHoursMulti', day: number, time?: Array<string | null> | null } | null> | null, special_delivery_hours?: Array<{ __typename?: 'SpecialOpeningHoursMulti', day: string, time?: Array<string | null> | null } | null> | null, preorder_hours_raw?: Array<{ __typename?: 'OpeningHoursMulti', day: number, time?: Array<string | null> | null } | null> | null, address?: { __typename?: 'Address', city?: string | null, streetname?: string | null, streetno?: string | null, street_extra?: string | null, state?: string | null, zip?: string | null } | null, invoice_collection?: { __typename?: 'InvoiceCollection', id: string, name: string, scope: Types.InvoiceCollectionScope } | null, delivery_address?: { __typename?: 'OpsDeliveryAddress', company?: string | null, first_name?: string | null, last_name?: string | null, streetname?: string | null, streetno?: string | null, state?: string | null, zip?: string | null, city?: string | null, additional_info?: string | null, email?: string | null } | null, brand?: { __typename?: 'Brand', id: string, name?: string | null, short_name?: string | null, logo?: string | null } | null, custom_invoice_items?: Array<{ __typename?: 'CustomInvoiceItem', type?: Types.CustomInvoiceItemType | null, total?: number | null, title?: string | null, description?: string | null, billing_frequency?: Types.BillingFrequency | null, billing_start_with_onboarding?: boolean | null, billing_start?: string | null } | null> | null, invoice_address?: { __typename?: 'Address', streetname?: string | null, streetno?: string | null, street_extra?: string | null, zip?: string | null, city?: string | null, country?: string | null } | null, images?: Array<{ __typename?: 'StoreImage', created_at?: string | null, source?: Types.ImageSource | null, url?: string | null, origin_url?: string | null, original_url?: string | null } | null> | null, phones?: Array<{ __typename?: 'StorePhone', id?: string | null, type?: string | null, sim_provided?: boolean | null, sim_card_number?: string | null, phone_number?: string | null, monthly_charge?: number | null, pin?: string | null, serial_number?: string | null, description?: string | null, billing_frequency?: Types.BillingFrequency | null, billing_start_with_onboarding?: boolean | null, billing_start?: string | null } | null> | null, return_boxes?: Array<{ __typename?: 'StoreReturnBox', id?: string | null, type?: string | null, location?: string | null, monthly_charge?: number | null, serviced?: boolean | null, billing_frequency?: Types.BillingFrequency | null, billing_start_with_onboarding?: boolean | null, billing_start?: string | null, publish_return_box_in_app?: boolean | null } | null> | null, vending_machines?: Array<{ __typename?: 'VendingMachine', id?: string | null, name?: string | null } | null> | null, container_groups?: Array<{ __typename?: 'ContainerGroup', id_int: number, image_urls?: Array<string | null> | null, name?: string | null, can_edit?: boolean | null, admin_only?: boolean | null, order_key?: number | null }> | null, non_usage_fee_info?: Array<{ __typename?: 'NonUsageFeeInfo', container_type_id: number, container_type_name: string, stock: number, avg_daily_checkouts: number, avg_weekly_checkouts: number, allowance?: number | null, send_back_suggestion?: number | null, non_return_cost?: number | null, exclusion_reason?: string | null } | null> | null, all_non_usage_fee_info: { __typename?: 'AllNonUsageFeeInfo', current_info: Array<{ __typename?: 'NonUsageFeeInfo', container_type_id: number, container_type_name: string, stock: number, avg_daily_checkouts: number, avg_weekly_checkouts: number, allowance?: number | null, send_back_suggestion?: number | null, non_return_cost?: number | null, exclusion_reason?: string | null }>, previous_info: Array<{ __typename?: 'PreviousNonUsageFeeInfo', month: number, year: number, is_net_receiver: boolean, exclusion_reason?: string | null, total: { __typename?: 'NonUsageFeeTotalInfo', allowance: number, avg_weekly_checkouts: number, non_return_cost: number, send_back_suggestion: number, stock: number } }> }, change_history?: Array<{ __typename?: 'StoreChangeHistory', old_values?: string | null, new_values?: string | null, changed_at?: string | null, changed_by?: string | null, changed_by_raw?: string | null } | null> | null, order_preferences?: { __typename?: 'StoreOrderPreferences', allow_mepal?: boolean | null, allow_koziol?: boolean | null } | null, mini_returners?: Array<{ __typename?: 'StoreMiniReturner', id: string, monthly_charge: number, billing_start?: string | null, billing_start_with_onboarding: boolean }> | null, tap2borrow_devices?: Array<{ __typename?: 'StoreTap2BorrowDevice', id: string, type: Types.StoreTap2BorrowDeviceType, monthly_charge: number, billing_start?: string | null, serial_number?: string | null, billing_start_with_onboarding: boolean, hide_on_invoice?: boolean | null }> | null, purchasing_order_gating?: { __typename?: 'PurchasingOrderGating', needs_purchasing_order_number: boolean, source: Types.PurchasingOrderGatingSource, source_account_id?: string | null, source_account_name?: string | null, purchasing_order_email?: string | null } | null, default_carriers?: Array<{ __typename?: 'DefaultCarrierEntry', carrier_service: Types.OpsOrderCarrierService, carrier: Types.OpsOrderCarrier }> | null, effective_default_carriers: Array<{ __typename?: 'DefaultCarrierEntry', carrier_service: Types.OpsOrderCarrierService, carrier: Types.OpsOrderCarrier }>, available_carrier_services: Array<{ __typename?: 'AvailableCarrierService', carrier: Types.OpsOrderCarrier, services: Array<Types.OpsOrderCarrierService> }> };

export const StoreAdminFragmentFragmentDoc = gql`
    fragment StoreAdminFragment on Store {
  id
  geo_hash
  eat_in_option
  online
  published
  can_preorder
  can_deliver
  always_online
  show_in_stats
  coming_soon
  permanently_removed
  name
  phone_number
  website
  description
  location_name
  region
  type
  available_soon
  available_from
  has_wolt
  lieferando_url
  wolt_url
  habgusta_url
  mjam_url
  labonapp_url
  ubereats_url
  split_app_url
  too_good_to_go_url
  rappi_url
  didi_food_url
  foodora_url
  google_places_id
  lonlat {
    longitude
    latitude
  }
  linked_city {
    id
    name
    store_count
  }
  food_info_de
  food_info_en
  description_de
  description_en
  description_fr
  description_nl
  description_no
  description_et
  description_el
  description_hu
  description_es
  description_sv
  description_pt
  description_lb
  description_da
  description_pl
  description_al
  description_ca
  description_eu
  description_gl
  contracted_date
  contract_end_date
  temporary_access_from
  onboarded_date
  test_period_end
  menu_link
  accepted_container_type_group_ids
  invoice_headline
  min_order_time
  cancelation_time
  labels {
    text
    color
    text_color
  }
  block_campaigns
  opening_hours_multi_raw {
    day
    time
  }
  special_opening_hours_multi {
    day
    time
  }
  delivery_hours_raw {
    day
    time
  }
  special_delivery_hours {
    day
    time
  }
  preorder_hours_raw {
    day
    time
  }
  address {
    city
    streetname
    streetno
    street_extra
    state
    zip
  }
  invoice_collection {
    id
    name
    scope
  }
  delivery_address {
    company
    first_name
    last_name
    streetname
    streetno
    state
    zip
    city
    additional_info
    email
  }
  brand {
    id
    name
    short_name
    logo
  }
  phone_from_vytal
  sim_info
  sim_phone_number
  sim_payment_automation
  offline_card_cost
  custom_invoice_items {
    type
    total
    title
    description
    billing_frequency
    billing_start_with_onboarding
    billing_start
  }
  invoice_email
  invoice_address {
    streetname
    streetno
    street_extra
    zip
    city
    country
  }
  legal_name
  onboarding_fee_vytal
  acquired_by
  acquired_at
  min_order_time
  cancelation_time
  debitor_account_number
  preorder_sms_number
  images {
    created_at
    source
    url
    origin_url
    original_url
  }
  internal_comment
  min_delivery_order_value
  min_delivery_time
  delivery_fee
  type
  phones {
    id
    type
    sim_provided
    sim_card_number
    phone_number
    monthly_charge
    pin
    serial_number
    description
    billing_frequency
    billing_start_with_onboarding
    billing_start
  }
  return_boxes {
    id
    type
    location
    monthly_charge
    serviced
    billing_frequency
    billing_start_with_onboarding
    billing_start
    publish_return_box_in_app
  }
  invoice_email_subject_prefix
  invoice_iban_name
  invoice_iban
  partner_newsletter_email
  country_code
  created_by
  food_categories
  currency
  partner_credits
  partner_credits_usable_until
  store_wide_discount_percent
  minimum_monthly_transaction_charge
  monthly_service_fee
  monthly_flat_fee
  use_circulation_based_billing
  offline_timeout
  google_places_id
  manual_overwrite_store_info
  disable_automatic_partner_invoice_sending
  disable_automatic_partner_charging
  external_salesforce_id
  external_zoho_crm_id
  charge_onboarding_fee
  external_vytal_id
  vending_machines {
    id
    name
  }
  store_layout
  store_layout_vending_machines_json
  tier
  revenue_tier
  feature_container_collection_enabled
  allow_inventory_checks_for_terminal_users
  allow_inventory_checks_for_terminal_users_until
  allow_inventory_checks_for_terminal_users_permanently
  additional_allowance
  additional_allowance_valid_until
  container_groups {
    id_int
    image_urls
    name
    can_edit
    admin_only
    order_key
  }
  last_google_opening_hours_sync
  is_net_receiver
  non_usage_fee_enabled
  charge_non_usage_fee
  non_usage_fee_info {
    container_type_id
    container_type_name
    stock
    avg_daily_checkouts
    avg_weekly_checkouts
    allowance
    send_back_suggestion
    non_return_cost
    exclusion_reason
  }
  dpd_pickup_compulsory
  all_non_usage_fee_info {
    current_info {
      container_type_id
      container_type_name
      stock
      avg_daily_checkouts
      avg_weekly_checkouts
      allowance
      send_back_suggestion
      non_return_cost
      exclusion_reason
    }
    previous_info {
      month
      year
      is_net_receiver
      exclusion_reason
      total {
        allowance
        avg_weekly_checkouts
        non_return_cost
        send_back_suggestion
        stock
      }
    }
  }
  vat_number
  permanently_closed
  employee_only
  send_nuf_info_to_invoice_address
  change_history {
    old_values
    new_values
    changed_at
    changed_by
    changed_by_raw
  }
  nuf_comment
  excluded_from_nuf_until
  currency_symbol
  order_preferences {
    allow_mepal
    allow_koziol
  }
  mini_returners {
    id
    monthly_charge
    billing_start
    billing_start_with_onboarding
  }
  tap2borrow_devices {
    id
    type
    monthly_charge
    billing_start
    serial_number
    billing_start_with_onboarding
    hide_on_invoice
  }
  has_return_box_published_in_app
  can_order_secondary_portfolio
  default_inventory_check_expiration_days
  new_inventory_checks_are_non_billable
  sustainability_reports_enabled
  invoice_routing_id
  order_number
  seller_id
  service_package_type
  service_package_start_date
  free_checkout_segment
  external_id
  invoice_yearly
  needs_purchasing_order_number
  purchasing_order_email
  purchasing_order_gating {
    needs_purchasing_order_number
    source
    source_account_id
    source_account_name
    purchasing_order_email
  }
  yearly_renewal_fee
  yearly_renewal_fee_month
  preferred_locale
  regular_payment_target_days
  sepa_2_percent_discount
  dunning_reminder_block_type
  dunning_reminder_block_reason
  dunning_reminder_block_until
  is_dunning_reminder_stopped
  inkassokennzeichen
  invoicing_disabled_permanently
  invoicing_disabled_until
  is_invoicing_currently_disabled
  onboarding_status
  removal_reason
  integrations
  credit_to_partner
  default_carriers {
    ...DefaultCarrierEntryFragment
  }
  effective_default_carriers {
    ...DefaultCarrierEntryFragment
  }
  available_carrier_services {
    ...AvailableCarrierServiceFragment
  }
}
    ${DefaultCarrierEntryFragmentFragmentDoc}
${AvailableCarrierServiceFragmentFragmentDoc}`;